// ===============================
// Text Handling (Matching & Sanitization)
// ===============================

export const containsText = (text, searchText) =>
  String(text).toLowerCase().trim().indexOf(searchText.toLowerCase().trim()) >
  -1;

export const onlyLettersAndSpaces = (text) => {
  return text.replace(/[^0-9a-zA-ZáéíóúüñâêîôûãõçÁÉÍÓÚÜÑÂÊÎÔÛÃÕÇ\s]/g, "");
};

// ===============================
// Number Formatting & Decimals
// ===============================

export const getOom = (median) => {
  let oom = {};
  if (Math.abs(median) >= 1e9) {
    oom = { div: 1e9, x: "b" };
  } else if (Math.abs(median) >= 1e6) {
    oom = { div: 1e6, x: "m" };
  } else if (Math.abs(median) >= 1e3) {
    oom = { div: 1e3, x: "k" };
  } else {
    oom = { div: 1, x: "" };
  }
  return oom;
};

export const formatNumber = (input) => {
  // Return number with 2 decimal places and commas as thousand separators
  if (input === null || input === undefined || isNaN(input)) {
    return "-";
  }

  const num = parseFloat(input);
  return num.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const getFirstTwoDecimals = (num) => {
  let numStr = num.toString();
  numStr = numStr.replace(",", ".");
  let parts = numStr.split(".");
  if (parts.length < 2) {
    return "00";
  }
  let decimals = parts[1].substring(0, 2);
  if (decimals.length < 2) {
    decimals += "0";
  }
  return decimals;
};

// ===============================
// Object Comparison
// ===============================

export const objectsEqual = (obj1, obj2) => {
  if (!obj1 || !obj2) return false;
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) return false;
  for (let key of keys1) {
    if (obj1[key] !== obj2[key]) return false;
  }
  return true;
};

export const deepEqual = (a, b) => {
  if (a === b) return true;
  if (
    typeof a !== "object" ||
    a === null ||
    typeof b !== "object" ||
    b === null
  )
    return false;

  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  if (keysA.length !== keysB.length) return false;

  return keysA.every(
    (key) =>
      Object.prototype.hasOwnProperty.call(b, key) && deepEqual(a[key], b[key]),
  );
};
